import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AccountForm } from "../components/accounts/AccountForm";
import { useCreateAccount } from "../hooks/accounts";
import { mapAccountsError } from "../lib/accounts-errors";
import { ApiError } from "../lib/api";

export function AccountNewPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorKey, setErrorKey] = useState<string | null>(null);
  const mutation = useCreateAccount();

  return (
    <section className="max-w-2xl mx-auto bg-white border border-slate-200 rounded p-6">
      <h1 className="text-xl font-semibold mb-4">{t("accounts.new.title")}</h1>
      <AccountForm
        mode="create"
        submitting={mutation.isPending}
        errorKey={errorKey}
        onSubmit={(data) => {
          setErrorKey(null);
          mutation.mutate(data, {
            onSuccess: (a) => navigate(`/accounts/${a.id}`),
            onError: (err) => {
              if (err instanceof ApiError) setErrorKey(mapAccountsError(err.code));
              else setErrorKey("errors.unknown");
            },
          });
        }}
        onCancel={() => navigate("/accounts")}
      />
    </section>
  );
}
